import {
    allFetch
} from "../Domain";

/**
 * @description 報表
 */
export const Report = (() => {
    /**
     * @description 打卡記錄
     */
    const WorkClockRecordStatistic = async function (obj = {
        status: '',
        date_start: '',
        date_end: '',
        user_ids: '',
        company_id: '',
        general_manager_id: '',
        department_id: '',
        position_id: '',
        class_id: '',
        group_id: '',
        office_id: '',
        excel: '',
        page: 0,
        num_per_page: 10
    }) {
        return await allFetch('Report/WorkClockRecordStatistic', obj);
    }

    /**
     * @description 打卡記錄
     */
    const AttendanceStatistic = async function (obj = {
        date_start: '',
        date_end: '',
        user_ids: [],
        company_id: '',
        general_manager_id: '',
        department_id: '',
        position_id: '',
        class_id: '',
        group_id: '',
        office_id: '',
        excel: 'N',
        check_auditing: '',
        page: 0,
        num_per_page: 10
    }) {
        return await allFetch('Report/AttendanceStatistic', obj);
    }

    /**
     * @description 排班結果報表
     */
    const ScheduleXEmployeeReport = async function (obj = {
        date_start: '',
        date_end: '',
        user_ids: [],
        company_id: '',
        general_manager_id: '',
        department_id: '',
        position_id: '',
        class_id: '',
        group_id: '',
        office_id: '',
        excel: 'N',
        page: 0,
        num_per_page: 10
    }) {
        return await allFetch('Report/ScheduleXEmployeeReport', obj);
    }

    /**
     * @description 請假紀錄報表
     */
    const LeaveRecordReport = async function (obj = {
        date_start: '',
        date_end: '',
        user_ids: [],
        company_id: '',
        general_manager_id: '',
        department_id: '',
        position_id: '',
        class_id: '',
        group_id: '',
        office_id: '',
        excel: 'N',
        page: 0,
        num_per_page: 10
    }) {
        return await allFetch('Report/LeaveRecordReport', obj);
    }

    /**
     * @description 剩餘特休報表
     */
    const LeaveRemainAnnualReport = async function (obj = {
        isresign: '',
        user_ids: [],
        company_id: '',
        general_manager_id: '',
        department_id: '',
        position_id: '',
        class_id: '',
        group_id: '',
        office_id: '',
        excel: 'N',
        page: 0,
        num_per_page: 10
    }) {
        return await allFetch('Report/LeaveRemainAnnualReport', obj);
    }

    /**
    * @description 使用者資訊報表
    */
    const UserReport = async function (obj = {
        username: '',
        name: '',
        company_id: '',
        general_manager_id: '',
        department_id: '',
        position_id: '',
        class_id: '',
        group_id: '',
        office_id: '',
        disable: '',
        isresign: '',
        ul_id: '',
        page: 0,
        num_per_page: 10
    }) {
        return await allFetch('Report/UserReport', obj);
    }
    return {
        WorkClockRecordStatistic,
        AttendanceStatistic,
        ScheduleXEmployeeReport,
        LeaveRecordReport,
        LeaveRemainAnnualReport,
        UserReport
    }
})();